module.exports = __webpack_public_path__ + "h5/img/4-001.fc9fa254.png";